import { History } from 'history'
import { osFetch } from 'util/fetch'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface ServerToolArgs {
  toolName: string
  kwargs: Record<string, any>
  orgId: string
}

export const TOOL_NAME = 'call_server_tool'

export async function CallServerToolCall(fc: LiveFunctionCall, history: History, orgId: number | undefined) {
  const args = fc.args as ServerToolArgs
  const toolName = fc.name

  if (!fc.osAssistantCode) {
    throw new Error('Assistant code is required for server tool calls')
  }

  const response = await osFetch(
    `${window.API_ROOT}/api/ada/${fc.osAssistantCode}/tools/${toolName}/`,
    {
      method: 'POST',
      headers: window.Utils.tokenAuthHeaders({
        'X-CSRFToken': window.getCookie('csrftoken'),
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        org_id: orgId,
        kwargs: args,
      }),
    }
  )

  if (!response.ok) {
    const errorBody = await response.text()
    throw new Error(`Server tool ${toolName} failed (${response.status}): ${errorBody.slice(0, 200)}`)
  }

  return response.json()
}
